import { render, staticRenderFns } from "./CommentsAppendix.vue?vue&type=template&id=28f73a0a&scoped=true"
import script from "./CommentsAppendix.vue?vue&type=script&lang=js"
export * from "./CommentsAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f73a0a",
  null
  
)

export default component.exports